import graphql__7d099150ff28fcb99425 from "./__generated__/CityWalkHome_participativeModule.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";
import { defineMessages } from "react-intl";

import MapSidebar from "../Maps/MapSidebar";
import MapPanelActions from "../Maps/MapPanel/MapPanelActions";
import Button from "../Buttons/Button";
import { useFormatMessageWithCustomization } from "../Intl/Context";
import { useNavigateTo } from "../Routes/RoutesContext";
import { useMapContext } from "../Maps/MapContext";

import { setCityWalkActive, setCityWalkCurrentWaypoint } from "../../reducers/cityWalks";

const CityWalkHome = props => {
  const participativeModule = useFragment(
    CityWalkHome_participativeModule,
    props.participativeModule
  );
  const { slug: participativeModuleSlug, visualization: cityWalk } = participativeModule;
  const { waypoints } = cityWalk;

  const { mapKey } = useMapContext();

  const translateWithCustomization = useFormatMessageWithCustomization(
    participativeModule.visualization.customIntlMessages
  );
  const startRemoteWalk = translateWithCustomization(intlMessages.startRemoteWalk);

  const currentWaypoint = waypoints && waypoints[0];
  const cityWalkWaypointId = currentWaypoint?.id;

  const dispatch = useDispatch();
  const navigateTo = useNavigateTo();

  const handleStartRemoteWalkClicked = useCallback(() => {
    dispatch(setCityWalkActive(mapKey, true));
    dispatch(setCityWalkCurrentWaypoint(mapKey, currentWaypoint));

    navigateTo("cityWalkWaypoint", {
      participativeModuleSlug,
      cityWalkWaypointId
    });
  }, [
    participativeModuleSlug,
    cityWalkWaypointId,
    currentWaypoint,
    dispatch,
    mapKey,
    navigateTo
  ]);

  return (
    <MapSidebar
      map={participativeModule}
      sidebar={participativeModule}
      keepMapVisibleOnOpen
    >
      <MapPanelActions>
        <Button
          type="button"
          className="btn btn-primary btn-block-md"
          data-city-walk-start-button
          onClick={handleStartRemoteWalkClicked}
          label={startRemoteWalk}
        />
      </MapPanelActions>
    </MapSidebar>
  );
};

const CityWalkHome_participativeModule = graphql__7d099150ff28fcb99425;

export default CityWalkHome;

const intlMessages = defineMessages({
  startRemoteWalk: {
    id: "city_walk.index.startRemoteWalk",
    defaultMessage: "Démarrer la balade",
    description: "Libellé du bouton pour démarrer la balade"
  }
});
